import { ADDRESS_INPUT_ID, MAP_CONTAINER_ID } from './constants';

export const appTemplate = `
<div class="yadelivery-map">
	<input type="hidden" name="PERSON_TYPE" :value="params.personType">

	<div class="yadelivery-map__header">
		<h2>{{ loc('YADELIVERY_MAP_TITLE') }}</h2>
		<div v-if="!params.hideNotificationBanner" class="yadelivery-map__notification">
			<svg class="yadelivery-map__notification-icon" viewBox="0 0 20 20" fill="currentColor">
				<path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.168 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"/>
			</svg>
			<span>{{ loc('YADELIVERY_MAP_NOTIFICATION') }}</span>
		</div>
	</div>

	<div class="yadelivery-map__content">
		<div class="yadelivery-map__fields">
			<div class="yadelivery-map__field-group">
				<h4>{{ loc('YADELIVERY_MAP_ADDRESS_TITLE') }}</h4>
				<div class="yadelivery-map__input-wrap">
					<input
						type="text"
						class="yadelivery-map__input"
						id="${ADDRESS_INPUT_ID}"
						:placeholder="loc('YADELIVERY_MAP_ADDRESS_LABEL')"
						:readonly="params.enableSuggestions && isYandexSuggest"
					>
				</div>
				<button
					v-if="isModal"
					class="yadelivery-map__show-modal-btn"
					@click="showModal"
				>
					<svg viewBox="0 0 24 24" fill="none" width="20" height="20">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M12 20.62c-2.43-2.142-4.217-4.1-5.406-5.883C5.323 12.831 4.8 11.224 4.8 9.868 4.8 5.76 8.02 2.8 12 2.8s7.2 2.96 7.2 7.068c0 1.356-.523 2.963-1.794 4.87-1.189 1.781-2.976 3.74-5.406 5.882zm-.658 1.814c.378.325.938.325 1.316 0C18.188 17.675 21 13.52 21 9.868 21 4.696 16.903 1 12 1S3 4.696 3 9.868c0 3.652 2.811 7.807 8.342 12.566z" fill="currentColor"></path>
						<path d="M12 12a2 2 0 100-4 2 2 0 000 4z" fill="currentColor"></path>
					</svg>
					<span>{{ loc('YADELIVERY_MAP_SHOW_ON_MAP') }}</span>
				</button>
			</div>

			<div v-if="showWarehouseSelector" class="yadelivery-map__field-group">
				<h4>{{ loc('YADELIVERY_MAP_SELECT_WAREHOUSE') }}</h4>
				<div class="yadelivery-map__input-wrap yadelivery-map__select-wrap">
					<select
						class="yadelivery-map__input yadelivery-map__select"
						:value="selectedWarehouse"
						:disabled="isChangingWarehouse"
						@change="onWarehouseChange($event.target.value)"
					>
						<option
							v-for="wh in params.availableWarehouses"
							:key="wh.id"
							:value="wh.id"
						>
							{{ wh.name }}
						</option>
					</select>
				</div>
				<div v-if="isChangingWarehouse" class="yadelivery-map__warehouse-loading">
					<span class="yadelivery-map__spinner"></span>
					<span>{{ loc('YADELIVERY_MAP_LOADING') }}</span>
				</div>
			</div>

			<div v-if="showOrderParams" class="yadelivery-map__field-group">
				<h4>{{ loc('YADELIVERY_MAP_ORDER_PARAMS') }}</h4>
				<div class="yadelivery-map__order-params">
					<div v-if="showCostField" class="yadelivery-map__input-wrap">
						<input
							type="number"
							min="0"
							class="yadelivery-map__input"
							v-model="orderPrice"
							:placeholder="loc('YADELIVERY_MAP_ORDER_PRICE')"
							@change="onOrderPriceChange"
						>
					</div>
					<div v-if="showWeightField" class="yadelivery-map__input-wrap">
						<input
							type="number"
							min="0"
							class="yadelivery-map__input"
							v-model="orderWeight"
							:placeholder="loc('YADELIVERY_MAP_ORDER_WEIGHT') + ' (' + weightUnitLabel + ')'"
							@change="onOrderWeightChange"
						>
						<span v-if="weightInKg" class="yadelivery-map__weight-hint">
							{{ weightInKg }}
						</span>
					</div>
				</div>

				<button
					v-if="showCart"
					class="yadelivery-map__cart-btn"
					:disabled="isLoadingCart"
					@click="loadCartData"
				>
					<svg v-if="!isLoadingCart" width="16" height="16" viewBox="0 0 16 16" fill="none">
						<path d="M1 1h2.5l.8 2m0 0L6 9h6.5l2-6H4.3z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
						<circle cx="6" cy="13" r="1.5" fill="currentColor"/>
						<circle cx="12" cy="13" r="1.5" fill="currentColor"/>
					</svg>
					<span v-if="isLoadingCart" class="yadelivery-map__spinner"></span>
					{{ loc('YADELIVERY_MAP_LOAD_CART') }}
				</button>

				<div v-if="showCartPanel && cartData" class="yadelivery-map__cart-panel">
					<div class="yadelivery-map__cart-items">
						<div
							v-for="(item, idx) in cartData.items"
							:key="idx"
							class="yadelivery-map__cart-item"
						>
							<span class="yadelivery-map__cart-item-name">{{ item.name }}</span>
							<span class="yadelivery-map__cart-item-details">
								{{ item.quantity }} &times; {{ item.price }} {{ currency }}
								<template v-if="item.weight > 0">&middot; {{ (item.weight / weightToGramsMultiplier) }} {{ weightUnitLabel }}</template>
							</span>
						</div>
					</div>
					<div class="yadelivery-map__cart-totals">
						<div class="yadelivery-map__cart-totals-row">
							<span>{{ loc('YADELIVERY_MAP_CART_TOTAL_PRICE') }}:</span>
							<strong>{{ cartData.price }} {{ currency }}</strong>
						</div>
						<div class="yadelivery-map__cart-totals-row">
							<span>{{ loc('YADELIVERY_MAP_CART_TOTAL_WEIGHT') }}:</span>
							<strong>{{ (cartData.weight / weightToGramsMultiplier) }} {{ weightUnitLabel }}</strong>
						</div>
					</div>
					<button
						class="yadelivery-map__cart-use-btn"
						@click="useCartData"
					>
						{{ loc('YADELIVERY_MAP_USE_CART_DATA') }}
					</button>
				</div>
			</div>
		</div>

		<!-- Cost block -->
		<div :class="['yadelivery-map__cost-block', 'yadelivery-map__cost-block--' + costBlockState]">

			<!-- Initial state -->
			<template v-if="costBlockState === 'initial'">
				<div class="yadelivery-map__empty-state">
					<svg width="40" height="40" viewBox="0 0 24 24" fill="none">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M12 20.62c-2.43-2.142-4.217-4.1-5.406-5.883C5.323 12.831 4.8 11.224 4.8 9.868 4.8 5.76 8.02 2.8 12 2.8s7.2 2.96 7.2 7.068c0 1.356-.523 2.963-1.794 4.87-1.189 1.781-2.976 3.74-5.406 5.882zm-.658 1.814c.378.325.938.325 1.316 0C18.188 17.675 21 13.52 21 9.868 21 4.696 16.903 1 12 1S3 4.696 3 9.868c0 3.652 2.811 7.807 8.342 12.566z" fill="currentColor"></path>
						<path d="M12 12a2 2 0 100-4 2 2 0 000 4z" fill="currentColor"></path>
					</svg>
					<span>{{ loc('YADELIVERY_MAP_EMPTY_STATE') }}</span>
				</div>
				<p v-if="params.showInitialPrice && animatedPrice > 0">
					<span class="yadelivery-map__price-value" style="opacity: 0.4;">{{ animatedPrice }}</span>
					<span class="yadelivery-map__price-currency" style="opacity: 0.4;">{{ currency }}</span>
				</p>
			</template>

			<!-- Loading skeleton -->
			<template v-else-if="costBlockState === 'loading'">
				<div class="yadelivery-map__skeleton">
					<div class="yadelivery-map__skeleton-line yadelivery-map__skeleton-line--lg"></div>
					<div class="yadelivery-map__skeleton-line yadelivery-map__skeleton-line--md"></div>
					<div class="yadelivery-map__skeleton-line yadelivery-map__skeleton-line--sm"></div>
				</div>
			</template>

			<!-- Calculating -->
			<template v-else-if="costBlockState === 'calculating'">
				<div class="yadelivery-map__price-row">
					<span class="yadelivery-map__price-value">{{ animatedPrice }}</span>
					<span class="yadelivery-map__price-currency">{{ currency }}</span>
				</div>
				<div class="yadelivery-map__calculating-row">
					<span class="yadelivery-map__spinner"></span>
					<span>{{ loc('YADELIVERY_MAP_LOADING') }}</span>
				</div>
			</template>

			<!-- Success -->
			<template v-else-if="costBlockState === 'success'">
				<div class="yadelivery-map__cost-content">
					<div class="yadelivery-map__price-row">
						<span class="yadelivery-map__price-value">{{ animatedPrice }}</span>
						<span class="yadelivery-map__price-currency">{{ currency }}</span>
					</div>
					<div v-if="formattedDistance" class="yadelivery-map__distance-row">
						<span class="yadelivery-map__distance-value">{{ formattedDistance.value }}</span>
						<span class="yadelivery-map__distance-unit">{{ formattedDistance.unit }}</span>
					</div>
				</div>
				<div v-if="showZoneType" class="yadelivery-map__zone-badge" :class="'yadelivery-map__zone-badge--' + deliveryType">
					{{ deliveryType === 'in' ? loc('YADELIVERY_MAP_IN_ZONE') : deliveryType === 'out' ? loc('YADELIVERY_MAP_OUT_ZONE') : loc('YADELIVERY_MAP_COMBINED_ZONE') }}
				</div>
				<div v-if="deliveryTimeText" class="yadelivery-map__delivery-time">
					<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
						<path fill-rule="evenodd" d="M8 15A7 7 0 108 1a7 7 0 000 14zm.75-10.25a.75.75 0 00-1.5 0v3.5c0 .199.079.39.22.53l2 2a.75.75 0 101.06-1.06L8.75 7.94V4.75z" clip-rule="evenodd"/>
					</svg>
					<span>{{ loc('YADELIVERY_MAP_DELIVERY_TIME') }}: {{ deliveryTimeText }}</span>
				</div>
				<div v-if="warehouseName" class="yadelivery-map__warehouse">
					{{ loc('YADELIVERY_MAP_WAREHOUSE') }}: {{ warehouseName }}
				</div>
				<p class="yadelivery-map__detail-text">{{ loc('YADELIVERY_MAP_DETAIL_TEXT') }}</p>
			</template>

			<!-- Forbidden -->
			<template v-else-if="costBlockState === 'forbidden'">
				<p class="yadelivery-map__forbidden-text">{{ forbiddenText }}</p>
				<div v-if="errors.length > 0" class="yadelivery-map__error-list">
					<div v-for="(msg, idx) in errors" :key="idx" class="yadelivery-map__error-item">
						<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
							<path fill-rule="evenodd" d="M8 15A7 7 0 108 1a7 7 0 000 14zM6.28 5.22a.75.75 0 00-1.06 1.06L6.94 8 5.22 9.72a.75.75 0 101.06 1.06L8 9.06l1.72 1.72a.75.75 0 101.06-1.06L9.06 8l1.72-1.72a.75.75 0 00-1.06-1.06L8 6.94 6.28 5.22z" clip-rule="evenodd"/>
						</svg>
						<span>{{ msg }}</span>
					</div>
				</div>
			</template>

			<!-- Error -->
			<template v-else-if="costBlockState === 'error'">
				<div class="yadelivery-map__error-list">
					<div v-for="(msg, idx) in errors" :key="idx" class="yadelivery-map__error-item">
						<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
							<path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.168 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"/>
						</svg>
						<span>{{ msg }}</span>
					</div>
				</div>
			</template>

			<p v-if="costBlockState !== 'loading' && costBlockState !== 'initial'" class="yadelivery-map__info-text">
				{{ loc('YADELIVERY_MAP_INFO_TEXT') }}
			</p>
		</div>
	</div>

	<div v-if="isPageMap" class="yadelivery-map__map-section">
		<div id="${MAP_CONTAINER_ID}" ref="mapContainer" class="yadelivery-map__map" :style="mapStyle">
			<div class="yadelivery-map__map-alert"></div>
		</div>
		<button class="yadelivery-map__map-expand-btn" @click="toggleMapExpand">
			{{ mapExpanded ? loc('YADELIVERY_MAP_COLLAPSE_MAP') : loc('YADELIVERY_MAP_EXPAND_MAP') }}
		</button>
	</div>
</div>
`;
